module.exports = __webpack_public_path__ + "img/14-full-lg.1bf87404.jpg";